"use strict";import{IconChevron200 as e}from"../src/elements/IconChevron200.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-chevron200",e);
//# sourceMappingURL=sp-icon-chevron200.js.map
